import React from 'react'
import { connect } from 'redaction'
import { filterNav, links, constants, compose } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'

import HeaderNav from 'layouts/InsideLayout/Header/HeaderNav/HeaderNav'

import messages from './messages'
import s from './Nav.scss'


const getNav = (state, props) => {
  const {
    routing: {
      location: { pathname },
    },
  } = state

  const { isFatherDayBambooGiftSetEnabled } = props

  const isHowHandCreamsWorkPage = pathname === links.howHandCreamsWork
  const isHowItWorksPage = pathname === links.howItWorks

  let nav = [
    { title: messages.women, to: links.subscription.mainWomen },
    { title: messages.men, to: links.subscription.mainMen },
    { title: messages.howItWorks, to: isHowHandCreamsWorkPage ? links.howHandCreamsWork : links.howItWorks },
    {
      title: messages.gift, className: s.giftNavItem, subNav: [
        ...(
          isFatherDayBambooGiftSetEnabled ? [
            { title: messages.fathersDay, to: links.fathersDayGiftSet, dataTestId: 'fatherDay' },
          ] : []
        ),
        { title: messages.gifts, to: links.gifts, dataTestId: constants.testIds.headerNavDrop.gifts },
        { title: messages.giftCard, to: links.giftCard, dataTestId: constants.testIds.headerNavDrop.giftCard },
        { title: messages.giftSetsMen, to: links.giftSetsMen, dataTestId: constants.testIds.headerNavDrop.giftSetsMen },
        { title: messages.giftSetsWomen, to: links.giftSet, dataTestId: constants.testIds.headerNavDrop.giftSetsWomen },
        { title: messages.skincareSets, to: links.skincareSets, dataTestId: constants.testIds.headerNavDrop.skincareSets },
        { title: messages.giftSubscription, to: links.gift, dataTestId: constants.testIds.headerNavDrop.giftSubscription },
      ],
    },
  ]

  if (isHowHandCreamsWorkPage) {
    nav = nav.slice(2, nav.length)
  }

  if (isHowItWorksPage) {
    nav = nav.map((link, index) => {
      const { to, ...rest } = link

      const oldLink = {
        ...rest,
        toOLD: index ? links.homeMen : links.home,
      }

      return index < 2 ? oldLink : link
    })
  }

  return filterNav(nav)
}


const NoAuthNav = (props) => {
  const { className, nav } = props

  return (
    <HeaderNav className={className} uppercase items={nav} />
  )
}


export default compose(
  injectGlobals(({ getFeatureToggle }) => ({
    isFatherDayBambooGiftSetEnabled: getFeatureToggle(constants.features.fatherDayBambooGiftSet),
  })),
  connect({
    nav: getNav,
  }),
)(NoAuthNav)
